import React from 'react';
import SingleProductRatesInfo from './single-product/single-product.jsx';
import { connect } from 'react-redux';
import R from 'ramda';
import { checkIfProductWithNothingToShow } from '../../../../utils/mass-rate-change-helpers';

const RatesDetailContainer = ({ updateType, rateType, ...updateCategories }) => {
  const updateData = updateCategories[updateType];
  return (
    <div style={{ display: 'inline-block', padding: '0 24px 24px 24px', height: '500px', float: 'right', width: '35%', borderBottom: 'solid 1px #eeeeee' }}>
      <div style={{ overflowY: 'scroll', maxHeight: '476px' }}>
        {
          R.compose(
            products => products.map((product, index) => <SingleProductRatesInfo key={index} {...product} />),
            R.flatten,
            R.values,
            R.groupBy(R.prop('productId')),
            R.reject(checkIfProductWithNothingToShow(updateType, rateType)),
            R.propOr([], 'products')
          )(updateData)
        }
      </div>
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  updateType: contracting.massRateChange.get('updateType'),
  rateType: contracting.massRateChange.get('rateType'),
  seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
  offers: contracting.massRateChange.get('offers').toJS(),
  extras: contracting.massRateChange.get('extras').toJS(),
});

export default connect(mapStateToProps)(RatesDetailContainer);


// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/rates-detail/rates-detail.jsx